// extracted by mini-css-extract-plugin
module.exports =  {"container":"d30e7684c4--container--elH36","container-phone":"d30e7684c4--container-phone--eYooP"};